import { render } from "./ScanningCode.vue?vue&type=template&id=9c97cb68&scoped=true"
import script from "./ScanningCode.vue?vue&type=script&lang=js"
export * from "./ScanningCode.vue?vue&type=script&lang=js"

import "./ScanningCode.vue?vue&type=style&index=0&id=9c97cb68&lang=less&scoped=true"
import "./ScanningCode.vue?vue&type=style&index=1&id=9c97cb68&lang=less"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c97cb68"]])

export default __exports__